import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateResellerBlockStatus } from "./updateResellerBlockStatus.request";
import { UpdateResellerBlockStatusParams } from "./updateResellerBlockStatus.types";

const useUpdateResellerVerification = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    UpdateResellerBlockStatusParams
  >
) => {
  return useMutation({
    mutationFn: requestUpdateResellerBlockStatus,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateResellerVerification;
